<template>
	<div>
		<div style="height: 80px;"></div>
		<div style="background: #F8F8F8; height: 30px;line-height: 30px;">
			<div class="container">
				首页 > 新闻中心 > 企业动态 > 文章详情
			</div>
		</div>
		<!-- 新闻内容 -->
		<div class="container">
			<div style="height:  15px;"></div>
			<div class="pcpadding" style="background-color: white;width: 100%; ">
				<!-- 标题 -->
				<div style="color: #333333;font-weight: bold;font-size: 39px;line-height: 59px;">
					鞋业“奥斯卡”落户上海CHIC 奥云数据荣获“年度鞋履产业创新者”大奖
				</div>
				<!-- 时间 -->
				<div style="height: 25px;"></div>
				<div class="context_tiem alibabapuhuiti_bold">
					2022-04-01
				</div>

				<!-- 新闻内容 -->
				<div style="height: 35px;"></div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					2021年3月17日，2021CHIC中国服装服饰博览会在中国上海国家会展中心盛大开展。本次展会上CHIC展会和《Footwear
					News》杂志联合举办了中国鞋履成就奖颁奖盛典，NIKE（耐克）、FILA（斐乐）、李宁、特步、百丽等国际知名鞋企获得提名，其中，温州新生代创新型科技公司奥云数据成为本次盛典的一大亮点。
				</div>
				<img style="width: 100%;" src="../../static/news/1/1.png"></img>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					《Footwear News》（简称FN）杂志创刊于1945年，被誉为鞋界的“奥斯卡”，是全球时尚界最具权威性的专业鞋履期刊。它聚焦于鞋履的五大核心领域：
					产业、设计、娱乐、运动和科技；力图打造国内最专业的鞋类资讯媒体，为业内人士和鞋履爱好者提供一个交流互动的平台。
					奥云数据近年来在国内鞋履行业异军突起，凭借其C2M智能定制的核心业务模式，被诸多媒体评论为鞋履定制行业的“独角兽”。本次年度盛典上，奥云与众多著名鞋企同台领奖并获得了“年度鞋履产业行业创新者”的殊荣。
				</div>
				<img style="width: 100%;" src="../../static/news/1/2.png"></img>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					奥云数据通过其C2M大数据云平台为行业内传统制造企业提供大规模个性化智能定制的整体解决方案，已经成功帮助30余家传统工厂从过往大规模生产模式向个性化定制的模式转变，为鞋服产业数字化转型提供技术支持。未来，奥云计划通过C2M大数据云平台，帮助100家传统鞋企完成生产数字化升级，帮助3000个终端零售商完成店铺定制化升级。
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					这家温企的获奖，代表着行业对其C2M智能定制模式高度认可，也标志着温州的传统鞋履制造业开始谋求在大消费时代下的创新之道。
					奥云CEO潘少宝在发表获奖感言中说：“奥云目前是国内首家C2M智能定制平台，专为鞋行业提供C2M大规模个性化智能定制整体解决方案，通过奥云C2M大数据云平台，为鞋业上下游产业链实现大规模个性化生产赋能，并为消费者提供更多个性化美观、个性化舒适和定制化鞋履！”
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					附获奖企业名单：</br>
					NIKE×李娜——年度联名合作</br>
					特步——年度运动品牌</br>
					钟楚曦——年度风格偶像</br>
					FILA fusion——年度品牌</br>
					李宁——年度鞋款</br>
					GEOX——年度可持续引领者</br>
					奥云数据——年度鞋履产业创新者</br>
					LTL——年度零售商</br>
					百丽——年度企业</br>
				</div>






				<!-- 新闻内容end -->


			</div>
			<div style="height:  45px;"></div>
		</div>
		<!-- 新闻内容 end -->


	</div>
</template>
<script>
	export default {
		name: 'Newdetails1',
		components: {


		},
		data() {
			return {

			}
		},

	}
</script>

<style>
	.context_tiem {
		color: #5D8299;
		size: 17px;
	}

	@media (min-width: 1000px) {
		.pcpadding {
			padding: 55px 200px 55px 200px;
		}
	}
</style>
